<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Last 30 days sign up vs cancelled
    div#30daySale(style="width: 100%; height: 300px; margin: 0 auto")
</template>

<script>
import dashbaordService from '../../service.js'

export default {
  mounted() {
    this.getNewSignupCount()
  },
  methods: {
    getNewSignupCount() {
      return dashbaordService.getNewSignupCount()
        .then((data) => {
          if (data) {
            const daySignupCount = [];
            const cancelledCount = [];
            const startingDate = data.data.customerSignups[0].selected_date;
            const myear = this.$moment(startingDate).format('YYYY');
            const mmonth = this.$moment(startingDate).format('MM');
            const mday = this.$moment(startingDate).format('DD');

            // console.log('starting date', startingDate, myear, mmonth, mday)

            data.data.customerSignups.forEach((row) => {
              // console.log(row.total)
              daySignupCount.push(row.signinTotal);
              cancelledCount.push(row.cancelTotal);
            });

            // Area Chart
            const HighChartArea = $('#30daySale');
            if (HighChartArea.length) {
              HighChartArea.highcharts({
                credits: false,
                colors: ['#4a89dc', '#B20C24', '#3bafda'],
                chart: {
                  type: 'areaspline',
                },
                title: {
                  text: null,
                },
                legend: {
                  enabled: true,
                },
                xAxis: {
                  type: 'datetime',
                  dateTimeLabelFormats: {
                    day: '%e of %b',
                  },
                },
                yAxis: {
                  title: {
                    text: null,
                  },
                  gridLineColor: 'transparent',
                },
                plotOptions: {
                  series: {
                    pointStart: Date.UTC(myear, mmonth - 1, mday),
                    pointInterval: 24 * 3600 * 1000, // one day
                  },
                  areaspline: {
                    fillOpacity: 0.25,
                  },
                },
                series: [{
                  name: 'Sign Up',
                  data: daySignupCount,
                },
                {
                  name: 'Cancelled',
                  data: cancelledCount,
                }],
              });
            }
          }
        })
    },
  },
}
</script>
